import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getUsersService } from "@modules/users/services/queries/listUsers/service";

export const UsersAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      labelField="full_name"
      queryHook={getUsersService}
    />
  );
});

UsersAutocomplete.displayName = "UsersAutocomplete";
